import { forwardRef, type SVGProps } from 'react';

export type FigmaCaretUpIconProps = {} & Omit<SVGProps<SVGSVGElement>, 'css'>;

export const FigmaCaretUpIcon = forwardRef<SVGSVGElement, FigmaCaretUpIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 16 16">
    <path d="M8 6L11 10L5 10L8 6Z" fill="currentColor" />
  </svg>
));

FigmaCaretUpIcon.displayName = 'FigmaCaretUpIcon';
